/* eslint-disable require-jsdoc */
import React, { useState } from 'react';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import Avatar from 'react-avatar';
import Grid from '@mui/material/Grid/Grid';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu/Menu';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import Tooltip from '../Tooltip.js';
import { globalStyles, colors, fonts } from '../../theme/index.js';
import Text from '../Text.js';
import { useTheme } from '@mui/material/styles';
import * as localizationMaps from '../../localization/maps.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';

/**
 * 
 * @param {*} props 
 * @returns 
 */
const MemberCard = props => {
  const [anchorEl, setAnchorEl] = useState(null);
  const memberStatusMap = {
    0: 'Pending',
    1: 'Active',
    2: 'Account Disabled',
    3: 'Parental Leave',
    4: 'Leave of Absence',
    5: 'Temporary Lay Off',
    6: 'Disability',
    7: 'Strike',
    8: 'Late Applicant',
    9: 'Terminated',
    10: 'Approved Leave',
    11: 'Survivor Benefits',
    12: 'Severance'
  };
  const {
    member,
    division,
    onClick,
    id,
    testid,
    whitelabel
  } = props;
  const showMenu = division.access !== 'Read';
  const name = `${member.firstname} ${member.lastname}`;
  const theme = useTheme();
  const _handleMenuClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const _handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const _editUser = () => {
    _handleCloseMenu();
    props.onEditEmployee();
  };
  const _notifyUser = () => {
    _handleCloseMenu();
    props.sendNotification();
  };
  const _terminateUser = () => {
    _handleCloseMenu();
    props.terminateEmployee();
  };
  const styles = {
    cardBlock: {
      ...globalStyles.cardBlock,
      '&:hover': {
        borderLeft: `${theme.palette.primary.main} solid 5px`
      }
    },
    cardSubtitle: {
      color: colors.mainTextGrey,
      fontFamily: fonts.type.medium,
      fontSize: '12px',
      margin: '0',
      padding: '0'
    },
    cardTitle: {
      ...globalStyles.cardTitle,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    memberCard: globalStyles.memberCard,
    menu: {
      minWidth: '250px'
    },
    blue: {
      color: colors.brandGreen
    }
  };
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    sx: {
      ...styles.cardBlock,
      ...styles.memberCard
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2,
    sm: 2,
    md: 1
  }, /*#__PURE__*/React.createElement(Avatar, {
    name: name,
    size: "40",
    textSizeRatio: 3,
    round: true,
    fgColor: theme.palette.primary.main,
    color: theme.palette.primary.light
  })), /*#__PURE__*/React.createElement(Grid, {
    onClick: onClick,
    item: true,
    xs: 4,
    sm: 4,
    md: 6
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column",
    alignItems: "flex-start"
  }, /*#__PURE__*/React.createElement("p", {
    style: styles.cardTitle
  }, name), /*#__PURE__*/React.createElement("p", {
    id: id || testid,
    style: styles.cardSubtitle
  }, props.member.email))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 1,
    sm: 1,
    md: 1,
    sx: {
      textAlign: 'center'
    }
  }, props.division && /*#__PURE__*/React.createElement(Tooltip, {
    tip: division.description,
    arrow: true
  }, /*#__PURE__*/React.createElement("p", {
    style: styles.cardTitle
  }, division.title))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2,
    sm: 2,
    md: 2,
    style: {
      textAlign: 'center'
    }
  }, props.class && /*#__PURE__*/React.createElement(Tooltip, {
    tip: props.class.description,
    arrow: true
  }, /*#__PURE__*/React.createElement("p", {
    style: styles.cardTitle
  }, props.class.title))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 1,
    sm: 1,
    md: 1,
    style: {
      textAlign: 'center'
    }
  }, member.cert && member.enrollmentDate && member.status === 1 ? /*#__PURE__*/React.createElement("p", {
    style: {
      ...styles.cardTitle,
      ...styles.blue
    }
  }, i18n.t(tokens.labels.employees.live)) : /*#__PURE__*/React.createElement("p", {
    style: styles.cardTitle
  }, localizationMaps.fromEnglish("memberStatuses", memberStatusMap[member.status]))), showMenu && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2,
    sm: 1,
    md: 1,
    sx: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "Edit",
    onClick: _handleMenuClick,
    sx: {
      padding: "12px"
    }
  }, /*#__PURE__*/React.createElement(MoreVertIcon, null)), /*#__PURE__*/React.createElement(Menu, {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: _handleCloseMenu,
    disableAutoFocusItem: true,
    sx: {
      minWidth: "250px"
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    onClick: _editUser,
    sx: styles.menu
  }, /*#__PURE__*/React.createElement(Text, {
    color: "inherit",
    medium: true,
    display: "inline"
  }, i18n.t(tokens.buttons.edit))), props.sendNotification && /*#__PURE__*/React.createElement(MenuItem, {
    onClick: _notifyUser,
    sx: styles.menu
  }, /*#__PURE__*/React.createElement(Text, {
    color: "inherit",
    medium: true,
    display: "inline"
  }, i18n.t(tokens.buttons.notify))), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: _terminateUser,
    sx: styles.menu
  }, /*#__PURE__*/React.createElement(Text, {
    color: "inherit",
    medium: true,
    display: "inline"
  }, i18n.t(tokens.buttons.terminate))))));
};
export default MemberCard;